import React, { useState, useEffect, useRef, useContext } from 'react';

import { withRouter, useHistory, Redirect } from 'react-router-dom';
import { PageSettings } from '../../config/page-settings';
import { useAuth0 } from "@auth0/auth0-react";
import swal from 'sweetalert';
import Config from '../../Config';
import LoaderSpinner from '../../components/Loaderspinner/LoaderSpinner'

const Auth0response = (props) => {
    const context = useContext(PageSettings)
    let history = useHistory();
    const { user, isAuthenticated, getAccessTokenSilently, error, isLoading } = useAuth0();

    // const { name, email } = user;
    useEffect(() => {
        context.handleSetPageSidebar(false)
        context.handleSetPageHeader(false)
        context.handleSetPageContentFullWidth(true);
        return () => {
            context.handleSetPageSidebar(true)
            context.handleSetPageHeader(true)
            context.handleSetPageContentFullWidth(false);
        }
    }, [])
    // useEffect(async () => {
    //     console.log("isAuthenticated", isAuthenticated)
    //     if (!isLoading && isAuthenticated) {
    //         console.log("user", user)
    //         //CreateLogin()
    //     }
    //     else {
    //         console.log("isLoading", isLoading)
    //     }
    // }, [isLoading]);
    // useEffect(async () => {
    //     if (isLoading) {
    //         return <div>Loading ...</div>;
    //     }
    //     else if (!isAuthenticated) {
    //         console.log("authenticated: ", isAuthenticated);
    //         console.log("isLoading: ", isLoading);
    //     }
    //     else if (!isLoading && isAuthenticated) {
    //         console.log("authenticated 44: ", isAuthenticated);
    //         console.log("isLoading 45: ", isLoading);
    //         const { name, picture, email } = user;
    //         console.log("User", user)
    //     }
    // }, [isLoading]);
    useEffect(async () => {
        // if (!isLoading) {
        //     const token = await getAccessTokenSilently();
        //     if (isAuthenticated) {
        //         console.log("token", token)
        //         console.log("authenticated 44: ", isAuthenticated);
        //         console.log("isLoading 45: ", isLoading);
        //         const { name, picture, email } = user;
        //         console.log("User", user)
        //     }
        //     else if (!isLoading && !isAuthenticated) {
        //         console.log("authenticated 63: ", isAuthenticated);
        //         console.log("isLoading 63: ", isLoading);
        //         history.push('/Login');
        //     }

        // }
        // else {
        //     return <LoaderSpinner isrefresh={isLoading} />;
        // }
        // (async () => {

        // })();
        const fetchData = async () => {
            const token = await getAccessTokenSilently();
            await console.log("authenticated 76: ", isAuthenticated);
            console.log("isLoading 77: ", isLoading);
            //  console.log("token", token)
            if (isLoading) {
                console.log("isLoading 80: ", isLoading);
                return <LoaderSpinner isrefresh={isLoading} />;
            }
            else if (!isAuthenticated) {
                console.log("authenticated 83: ", isAuthenticated);
                console.log("isLoading 84: ", isLoading);
                return <LoaderSpinner isrefresh={isLoading} />;
                // history.push('/Login');
            }
            else if (!isLoading && isAuthenticated) {
                const token = await getAccessTokenSilently();
                console.log("token", token.toString())
                console.log("authenticated 90: ", isAuthenticated);
                console.log("isLoading 92: ", isLoading);
                // const { name, picture, email } = user;
                console.log("User", user)
                CreateLogin(user?.email, token)
            }
        }
        fetchData()
            .catch(console.error);
    }, [isLoading, isAuthenticated])

    // if (isLoading) {
    //     return <LoaderSpinner isrefresh={isLoading} />;
    // }
    // else if (!isLoading && isAuthenticated)  {
    //     const token =  getAccessTokenSilently();
    //     console.log("token", token)
    //     console.log("authenticated 44: ", isAuthenticated);
    //     console.log("isLoading 45: ", isLoading);
    //     // const { name, picture, email } = user;
    //     // console.log("User", user)
    //     CreateLogin(user?.email, token)
    // }
    // else if (!isLoading && !isAuthenticated) {
    //     console.log("authenticated 63: ", isAuthenticated);
    //     console.log("isLoading 63: ", isLoading);
    //     // history.push('/Login');
    // }

    const CreateLogin = (email, token) => {
        let isvalid = true;
        if (email === null || email === undefined || email === "") {
            isvalid = false;
        }

        if (isvalid === true) {
            fetch(Config.apiUrl + "UserCompany/GetFullUserDetailByEmailAddress?email=" + email,
                {
                    method: "GET",
                    headers: {
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Origin': '*'
                    },
                }).then((result) => {
                    result.json().then((resp) => {
                        if (resp?.id != undefined && resp?.id != null && resp?.id != "") {
                            localStorage.setItem('islogin', true);
                            localStorage.setItem('loginName', resp.name);
                            localStorage.setItem('loginUserID', resp.id);
                            localStorage.setItem('loginEmail', resp.email);
                            localStorage.setItem('loginRoleName', resp.roleName);
                            localStorage.setItem('loginUserImage', Config.contentUrl + resp.userImage);
                            localStorage.setItem('Auth0token', token);
                            // history.push('/dashboard/home');
                            history.push('/home');

                            //this.props.history.push({ pathname: '/dashboard/home' });
                        }
                        else {
                            history.push('/Login');
                            swal("Your Email And Password invalid !");
                        }
                    })
                }).catch((error) => {
                    swal("error !" + error);
                    console.error('There was an error!', error);
                    history.push('/Login');
                })
        }
        else {
            history.push('/Login');
        }
    }
    return (
        <div className="login login-with-news-feed">
            {/* <h1>Rajani</h1> */}
            <LoaderSpinner isrefresh={isLoading} />
        </div>
    )

}

export default Auth0response;